import React from 'react';
import {TextField} from "../TextField/TextField";

export const NumberField = (props) => {
    return <TextField type="number" {...props}/>
}